<div>
  <button mat-raised-button color="primary" [matMenuTriggerFor]="menu" class="w-100 btn-md event-btn">{{btnText}}</button>

  <mat-menu #menu="matMenu" xPosition="before" class="share-dropdown-menu">
    <div class="share-dropdown-title">{{btnText}}</div>
    
    <div class="share-dropdown-list">
      <a class="share-link" (click)="shareClick($event, CalendarItemEnum.Desktop)">
        <img height="22" width="22" src="/Content/Images/icons/celendar2.png" alt="Ics">
      </a>
      <a class="share-link" (click)="shareClick($event, CalendarItemEnum.Outlook)">
        <img height="20" width="20" src="/Content/Images/icons/soc2.png" alt="Outlook">
      </a>
      <a class="share-link" (click)="shareClick($event, CalendarItemEnum.Gmail)">
        <img height="17" width="11" src="/Content/Images/icons/google2.png" alt="Google">
      </a>
    </div>
  </mat-menu>
</div>